import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Supabase URL or Anon Key is missing. Check your .env file.')
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
  },
})

export type Profile = {
  id: string
  email: string
  name: string | null
  avatar: string | null
  role: 'admin' | 'moderator' | 'user'
  banned: boolean
  created_at: string
}

export type News = {
  id: string
  title: string
  subtitle: string | null
  summary: string | null
  excerpt: string | null
  content: string
  image_url: string | null
  category: string
  categories: string[] | null
  tags: string[]
  author: string
  source: string | null
  source_url: string | null
  meta_description: string | null
  slug: string
  status: 'rascunho' | 'publicado' | 'arquivado'
  is_featured: boolean
  is_headline: boolean
  is_breaking: boolean
  created_at: string
  published_at: string | null
  views: number
  posted_to_x: boolean
}

export type Comment = {
  id: string
  news_id: string
  user_id: string
  user_name: string
  user_avatar: string | null
  content: string
  parent_id: string | null
  likes: number
  status: 'aprovado' | 'oculto' | 'denunciado'
  created_at: string
}

export type Match = {
  id: string
  home_team: string
  away_team: string
  home_team_logo: string | null
  away_team_logo: string | null
  home_score: number
  away_score: number
  competition: string
  match_date: string
  status: 'programado' | 'ao_vivo' | 'encerrado'
  live_url: string | null
  is_live: boolean
  created_at: string
}

export type Video = {
  id: string
  title: string
  description: string | null
  url: string
  thumbnail: string | null
  category: string | null
  created_at: string
}

export type Standing = {
  id: string
  competition: string
  team: string
  team_logo: string | null
  position: number
  points: number
  played: number
  wins: number
  draws: number
  losses: number
  goals_for: number
  goals_against: number
  goal_difference: number
  updated_at: string
}
